<template>
    <div class="Jbman-preventiva-lancamento">
        <PageTitle icon="fa fa-cogs" main="Preventiva"
            sub="Cadastros \ Lançamentos \ Relatórios" />
        <div class="Jbman-preventiva-lancamento-tabs">
            <b-card no-body>
                <b-tabs>     
                    
                    <b-tab title="Monitoramento" active><JbManPreventivaOsErp /></b-tab>                                 
                    <b-tab title="Painel"><JbManPreventivaPainel /></b-tab>                                 
                    <b-tab title="Ordens de serviço com observações" ><JbManPreventivaObservacao /></b-tab>                                                            
                    <b-tab title="KM atual serviços"><JbManPreventivaOsHistorico /></b-tab>
                    
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import JbManPreventivaOsErp from '../sambaiba/JbManPreventivaOsErp'
import JbManPreventivaPainel from '../sambaiba/JbManPreventivaPainel'
import JbManPreventivaObservacao from '../sambaiba/JbManPreventivaObservacao'
import JbManPreventivaOsHistorico from '../sambaiba/JbManPreventivaOsHistorico'


export default {
    name: 'JbSambaibaPreventivaOpcoes',    
    components: { PageTitle, JbManPreventivaOsErp,JbManPreventivaObservacao,JbManPreventivaPainel,JbManPreventivaOsHistorico }
}
</script>

<style>

</style>
